import { Route, Routes } from "react-router-dom";
import { ContractsList } from "./ContractsList/ContractsList";
import { ContractCreate } from "./ContractCreate/ContractCreate";
import { ContractView } from "./ContractView";
import { CreateJobAndSchedule } from "./CreateJobAndSchedule/CreateJobAndSchedule";
import { PrivateRoute } from "../../../keycloak";
import { UserRoles } from "../../../constants/userRoles";

export const Contracts = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.CONTRACT_VIEW],
            }}
          />
        }
      >
        <Route index path="" element={<ContractsList />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.JOB_CREATE],
            }}
          />
        }
      >
        <Route
          path={`/create/job/:leadId`}
          element={<CreateJobAndSchedule />}
        />
      </Route>
      {/*
        Editing an existing series' per-day pattern. Same screen as the create
        route, plus the job id it loads the pattern from.
      */}
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.JOB_UPDATE],
            }}
          />
        }
      >
        <Route
          path={`/edit/job/:leadId/:jobId`}
          element={<CreateJobAndSchedule />}
        />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.CONTRACT_CREATE],
            }}
          />
        }
      >
        <Route path={`/create/:leadId`} element={<ContractCreate />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.CONTRACT_VIEW],
            }}
          />
        }
      >
        <Route path={`/:contractId/:leadId/*`} element={<ContractView />} />
      </Route>
    </Routes>
  );
};
